<template>
    <a
      href="https://wa.me/6281234567890"
      class="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i class="fab fa-whatsapp"></i>
    </a>
  </template>
  
  <script>
  import '../style/whatsapp.css'
  export default {
    name: 'WhatsappFloat',
  }
  </script>
  
  <style scoped>
 
  </style>
  